import Builder from '../../utils/redux/builder';

const builder = new Builder({
  name: 'service',
  initialState: {
    serviceData: null,
  },
  reducers: {
    setServiceData(state, { payload }) {
      state.serviceData = payload;
    },
  },
});

const service = builder.create().export();

export const { useService } = service.selectors;
export const { setServiceData } = service.actions;

export default service;
